/**
 * @ngdoc filter
 * @name abookApp.filter:capitalize
 * @description
 * # capitalize
 *
 * Usage
 *
 * {{ string | capitalize}}             CAPITALIZE FIRST LETTER IN FIRST WORD.
 * {{ string | capitalize:true }}       CAPITALIZE FIRST LETTER IN ALL WORDS.
 *
 */

export default function capitalize() {
    return function (input, all) {
        var regX = all ? /([^\W_]+[^\s-]*) */g : /([^\W_]+[^\s-]*)/;
        return input
            ? input.replace(regX, function (txt) {
                  return (
                      txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
                  );
              })
            : "";
    };
}
